export var emptyStep = {
  id: "",
  name: ""
};